import { Thermometer, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Warmtepomp = () => {
  const projectImages =[
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773787174/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773787174702.jpg",
      alt: "Warmtepomp binnenunit met buffervat en leidingwerk"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773787174/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773787174696.jpg",
      alt: "Panasonic Aquarea buitenunit strak aan de muur"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773787175/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773787175567.jpg",
      alt: "Remeha hybride warmtepomp installatie"
    },
    {
      src: "https://res.cloudinary.com/dhyp5qe9q/image/upload/v1773787175/episolo/chat-attachments/user-jh73xrq668fpmhwhwhtrjm7vk97z918r-1773787175456.jpg",
      alt: "Overzicht van technisch leidingwerk voor warmtepomp"
    }
  ];

  return (
    <div className="pt-24 pb-20">
      {/* Hero Section */}
      <div className="bg-gray-900 text-white py-20 mb-16">
        <div className="container mx-auto px-4 max-w-5xl text-center">
          <div className="inline-flex items-center justify-center p-4 bg-orange-600/20 rounded-2xl mb-6">
            <Thermometer className="h-12 w-12 text-orange-500" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Warmtepompen</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
            Zet de stap naar een duurzame en gasloze toekomst met een hybride of all-electric warmtepomp.
          </p>
          <Button asChild size="lg" className="bg-orange-600 hover:bg-orange-700 font-bold px-8">
            <Link to="/offerte">Vraag direct een offerte aan</Link>
          </Button>
        </div>
      </div>

      <div className="container mx-auto px-4 max-w-6xl">
        {/* Content Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-3xl font-bold mb-6">Klaar voor de toekomst</h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Met een warmtepomp verwarmt u uw woning op een duurzame manier, door warmte uit de buitenlucht te halen. Of u nu kiest voor een hybride systeem naast uw huidige cv-ketel of volledig van het gas af wilt gaan, wij adviseren u over de beste oplossing voor uw specifieke woonsituatie.
            </p>
            <ul className="space-y-4 mb-8">
              {[
                "Aanzienlijke besparing op gaskosten",
                "Verhoogt de waarde en het energielabel van uw woning",
                "Aantrekkelijke overheidssubsidies (ISDE)",
                "Vakkundige installatie en inregeling"
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle2 className="h-6 w-6 text-orange-500 shrink-0" />
                  <span className="text-gray-800 font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] md:aspect-square group">
            <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10" />
            <img 
              src={projectImages[1].src} 
              alt="Warmtepomp buitenunit installatie" 
              className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" 
            />
          </div>
        </div>

        {/* Video Section */}
        <div className="mb-24 max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4">Bekijk ons werk in actie</h2>
            <p className="text-gray-600">Een korte impressie van een warmtepomp installatie.</p>
          </div>
          <div className="w-full aspect-video rounded-2xl overflow-hidden shadow-2xl border border-gray-100">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/-B14w4ATIRU"
              title="SpiroTechniek Installatie Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Project Gallery */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Onze Warmtepomp Projecten</h2>
            <p className="text-gray-600">Een greep uit onze recente installaties in de praktijk.</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {projectImages.map((img, i) => (
              <div key={i} className="relative rounded-2xl overflow-hidden aspect-[4/3] shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer">
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300 z-10" />
                <img 
                  src={img.src} 
                  alt={img.alt} 
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" 
                />
                <div className="absolute bottom-0 left-0 w-full p-6 z-20 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                    {img.alt}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="bg-orange-50 rounded-3xl p-12 text-center">
          <h2 className="text-3xl font-bold mb-4">Benieuwd wat een warmtepomp u oplevert?</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">Wij rekenen graag voor u uit welk type warmtepomp geschikt is en wat de verwachte besparing en terugverdientijd zal zijn.</p>
          <Button asChild size="lg" className="bg-orange-600 hover:bg-orange-700 text-white font-bold">
            <Link to="/offerte">Ontvang vrijblijvend advies <ArrowRight className="ml-2 h-5 w-5"/></Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Warmtepomp;
